var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7919 0.819336L23.6035 3.89211H28.4739C30.1639 3.89211 31.5466 5.27485 31.5466 6.96487V25.4015C31.5466 27.0915 30.1639 28.4743 28.4739 28.4743H3.8917C2.20168 28.4743 0.818934 27.0915 0.818934 25.4015V6.96487C0.818934 5.27485 2.20168 3.89211 3.8917 3.89211H8.76204L11.5736 0.819336H20.7919ZM16.1828 23.8651C20.4232 23.8651 23.8647 20.4236 23.8647 16.1832C23.8647 11.9428 20.4232 8.50126 16.1828 8.50126C11.9424 8.50126 8.50086 11.9428 8.50086 16.1832C8.50086 20.4236 11.9424 23.8651 16.1828 23.8651Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.8fa43f1717f5f25969e863c060014e48.svg";
export { ForwardRef as ReactComponent };